export default {
	title: 'virtual_components',
	components: [
		{
			title: 'virtual_components',
			component: 'virtual_components',
			min_ver: '1.3.99',
		},
	],
};
